import { Box, FormControl, FormGroup, IconButton, InputLabel, Select, TextField, MenuItem, Autocomplete } from '@mui/material';
import { GridCsvGetRowsToExportParams, gridVisibleSortedRowIdsSelector, useGridApiContext, GridCsvExportOptions } from '@mui/x-data-grid';
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import SearchIcon from '@mui/icons-material/Search';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CountryAllRequest } from 'src/actions/countryActions';
import { useSelector } from 'src/reducers';
import { ProjectStatus } from 'src/constants';
import CachedIcon from '@mui/icons-material/Cached';
import { Download } from '@mui/icons-material';
import { ProjectAllRequestData } from 'src/actions/projectActions';
import { Project } from 'src/types/projectTypes';
import { ClientAllRequestData, ClientAllRequestDataWithFilter } from 'src/actions/clientActions';
import { SupplierAllRequestData } from 'src/actions/supplierActions';
import { Client } from 'src/types/clientTypes';
import { Supplier } from 'src/types/supplierTypes';
import { UserAllRequestData } from 'src/actions/userActions';
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';

interface ToolbarProps {
  filters: any;
  state: any;
  setSearch: any;
  filterTypes: any;
  setFilters: any;
  reloadAction: any;
  exportFileName: string;
  multilinesearch: boolean;
  searchwidth: string;
  searchheight: number;
  exportIdentfier: any,
  exportIdentifierLoading: any
}

const ListToolbar = ({ filters, filterTypes, exportIdentfier, exportIdentifierLoading, state, setFilters, reloadAction, exportFileName, multilinesearch, searchwidth, searchheight }: ToolbarProps) => {

  const dispatch = useDispatch();
  const { loading, countries } = useSelector(state => state.country);
  const { clients } = useSelector(state => state.client);
  const { users } = useSelector(state => state.user);
  const { projects } = useSelector(state => state.project);
  const { suppliers } = useSelector(state => state.supplier);

  const setFilterItem = (type: string, value: any) => {
    if (!value) {
      delete filters[type];
      setFilters({ ...filters })
    }
    else {
      var newobj = { [type]: value };
      setFilters({ ...filters, ...newobj });
    }
  }

  const getFilterItem = (type: string) => {
    return filters[type] || '';
  }

  const getRowsFromCurrentPage = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridVisibleSortedRowIdsSelector(apiRef);


  const apiRef = useGridApiContext();

  const handleExport = (options: GridCsvExportOptions) => apiRef.current.exportDataAsCsv(options);


  useEffect(() => {
    if (filterTypes.includes('countries')) dispatch(CountryAllRequest());
  }, [filterTypes.includes('countries')])


  useEffect(() => {
    if (filterTypes.includes('project')) dispatch(ProjectAllRequestData());
  }, [filterTypes.includes('project')])

  useEffect(() => {
    if (filterTypes.includes('client')) dispatch(ClientAllRequestData(''));
  }, [filterTypes.includes('client')])

  useEffect(() => {
    if (filterTypes.includes('clientdiy')) dispatch(ClientAllRequestDataWithFilter({ isApiIntegration: true }));
  }, [filterTypes.includes('clientdiy')])


  useEffect(() => {
    if (filterTypes.includes('supplier')) dispatch(SupplierAllRequestData());
  }, [filterTypes.includes('supplier')])


  useEffect(() => {
    if (filterTypes.includes('user')) dispatch(UserAllRequestData());
  }, [filterTypes.includes('user')])

  const status = [
    { label: "Active", value: "true" },
    { label: "InActive", value: "false" },
  ]


  return (
    <Box sx={{ display: 'flex', padding: 2, paddingTop: 0, justifyContent: 'space-between' }}>
      <Box>
        <FormGroup className="MuiFormGroup-options" row>
          {filterTypes.includes('search') && <FormControl sx={{ mt: 3, mr: 2 }} variant="standard">
            <TextField
              multiline={multilinesearch ? true : false}
              fullWidth
              name="search"
              maxRows={searchheight}
              variant="standard"
              sx={{ width: searchwidth || 300 }}
              onChange={(e) => e.target.value ? setFilterItem('search', e.target.value) : setFilterItem('search', '')}
              placeholder="Search…"
              InputProps={{
                startAdornment: <SearchIcon fontSize="small" />,
              }
              }
            />
          </FormControl>}

          {filterTypes.includes('searcharea') && <FormControl sx={{ mt: 3, mr: 2 }} variant="standard">
            <TextField
              minRows={5}
              maxRows={8}
              multiline={true}
              fullWidth
              name="search"
              variant="standard"
              sx={{ width: 400 }}
              onChange={(e) => e.target.value ? setFilterItem('search', e.target.value) : setFilterItem('search', '')}
              placeholder="Search…"
            />
          </FormControl>}
          {filterTypes.includes('exportIdentifier') &&
            <FormControl sx={{ mt: 3, mr: 2 }} variant="standard">
              <LoadingButton
                loading={exportIdentifierLoading}
                onClick={() => exportIdentfier()}
                variant="contained"

              >
                Export
              </LoadingButton>
            </FormControl>
          }

          {filterTypes.includes('countries') && <FormControl sx={{ m: 1, minWidth: 150 }} variant="standard">
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              onChange={(e, value: any) => value ? setFilterItem('countryId', value.value) : setFilterItem('countryId', '')}
              options={countries}
              loading={loading}
              sx={{ width: 300 }}
              renderInput={(params) => <TextField variant="standard" {...params} label="Countries" />}
            />
          </FormControl>}
          {filterTypes.includes('project') && <FormControl sx={{ m: 1, minWidth: 150 }} variant="standard">
            <InputLabel>Group Projects</InputLabel>
            <Select name="project" defaultValue="" value={getFilterItem('project')} onChange={(e) => setFilterItem('project', e.target.value)} >
              {projects && projects.map((project: Project) =>
                <MenuItem key={project._id} value={project._id}>{project.projectCode + "_" + project.projectName}</MenuItem>
              )}
            </Select>
          </FormControl>}
          {filterTypes.includes('client') && <FormControl sx={{ m: 1, minWidth: 150 }} variant="standard">
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              onChange={(e, value: any) => value ? setFilterItem('client', value.value) : setFilterItem('client', '')}
              options={clients}
              loading={loading}
              renderInput={(params) => <TextField variant="standard" {...params} label="Clients" />}
            />

          </FormControl>}
          {filterTypes.includes('clientdiy') && <FormControl sx={{ m: 1, minWidth: 150 }} variant="standard">
            <InputLabel> Clients</InputLabel>
            <Select name="client" defaultValue="" value={getFilterItem('client')} onChange={(e) => setFilterItem('client', e.target.value)} >
              <MenuItem value="">any</MenuItem>
              {clients.map((client: Client) =>
                <MenuItem key={client._id} value={client._id}>{client.clientName}</MenuItem>
              )}
            </Select>
          </FormControl>}
          {/* {filterTypes.includes('supplier') && <FormControl sx={{ m: 1, minWidth: 150 }} variant="standard">
          <Autocomplete
                disablePortal
                id="combo-box-demo"
                onChange={(e, value: any) => value ? setFilterItem('supplier', value.value) : setFilterItem('supplier', '')}
                options={suppliers}
                loading={loading}
                renderInput={(params) => <TextField variant="standard" {...params} label="Suppliers" />}
              />
              
          </FormControl>} */}
          {filterTypes.includes('supplier') && <FormControl sx={{ m: 1, minWidth: 150 }} variant="standard">
            <InputLabel> Suppliers</InputLabel>
            <Select name="supplier" defaultValue="" value={getFilterItem('supplier')} onChange={(e) => setFilterItem('supplier', e.target.value)} >
              <MenuItem value="">any</MenuItem>
              {suppliers.map((supplier: Supplier) =>
                <MenuItem key={supplier._id} value={supplier._id}>{supplier.supplierName}</MenuItem>
              )}
            </Select>
          </FormControl>}
          {filterTypes.includes('status') &&
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} >
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                onChange={(e, value: any) => value ? setFilterItem('isActive', value.value) : setFilterItem('isActive', '')}
                options={status}
                loading={loading}
                renderInput={(params) => <TextField variant="standard" {...params} label="Status" />}
              />
            </FormControl>}
          {filterTypes.includes('user') &&
            <FormControl variant="standard" sx={{ m: 1, minWidth: 140 }} >
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                onChange={(e, value: any) => value ? setFilterItem('user', value.value) : setFilterItem('user', '')}
                options={users}
                loading={loading}
                renderInput={(params) => <TextField variant="standard" {...params} label="Manager" />}
              />
            </FormControl>}
          {filterTypes.includes('projectStatus') &&
            <FormControl variant="standard" sx={{ m: 1, minWidth: 140 }} >
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                onChange={(e, value: any) => value ? setFilterItem('projectStatus', value.value) : setFilterItem('projectStatus', '')}
                options={ProjectStatus}
                loading={loading}
                sx={{ width: 300 }}
                renderInput={(params) => <TextField variant="standard" {...params} label="Project Status" />}
              />
            </FormControl>
          }
          {filterTypes.includes('sortDate') && <Box>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 140 }} >
              <InputLabel >Sort By</InputLabel>
              <Select name="sortDate" value={getFilterItem('sortDate')} onChange={(e) => setFilterItem('sortDate', e.target.value)} >
                <MenuItem value={1}>Today</MenuItem>
                <MenuItem value={2}>Last 7 Days</MenuItem>
                <MenuItem value={3}>This Month</MenuItem>
              </Select>
            </FormControl>
          </Box>}
          {filterTypes.includes('dateRange') && <Box>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 140 }} >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  inputFormat="dd/MM/yyyy"
                  label="Min Date"
                  onChange={(date: Date | null) => setFilterItem('minDate', date)}
                  value={getFilterItem('minDate') || null}
                  renderInput={(params) => <TextField
                    variant="standard"
                    fullWidth {...params} />}
                />
              </LocalizationProvider>
            </FormControl>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 140 }} >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  minDate={getFilterItem('minDate')}
                  inputFormat="dd/MM/yyyy"
                  label="Max Date"
                  value={getFilterItem('maxDate') || null}
                  onChange={(date: Date | null) => setFilterItem('maxDate', date)}
                  renderInput={(params) => <TextField
                    variant="standard"
                    fullWidth {...params} />}
                />
              </LocalizationProvider>
            </FormControl>
          </Box>}
        </FormGroup>
      </Box>
      <Box>
        <FormGroup className="MuiFormGroup-options" row>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            {reloadAction && <IconButton onClick={() => reloadAction()}><CachedIcon /></IconButton>}
          </Box>
          {filterTypes.includes('export') &&
            <FormControl variant="standard" sx={{ mt: 3, ml: 1, minWidth: 10 }} >
              <IconButton onClick={() => handleExport({ getRowsToExport: getRowsFromCurrentPage, fileName: exportFileName })}>
                <Download />
              </IconButton>
            </FormControl>}
        </FormGroup>
      </Box>
    </Box>
  );
}

export default ListToolbar;